/// <reference path="../types/global.d.ts" />
declare const Salla: any;

import * as createStore from "store/src/store-engine"
import * as localStorage from "store/storages/localStorage"
import * as sessionStorage from "store/storages/sessionStorage"
import * as cookieStorage from "store/storages/cookieStorage"
import * as memoryStorage from "store/storages/memoryStorage"
import IStorage, { ItemWithTTL, StoreJsAPI } from "../types/storage"

const localStore = createStore.createStore([
  localStorage,
  sessionStorage,
  cookieStorage,
  memoryStorage,
], []);

const sessionStore = createStore.createStore([sessionStorage], []);
const cookieStore = createStore.createStore([cookieStorage], []);


export default class Storage implements IStorage {
  store: StoreJsAPI;
  session: StoreJsAPI;
  cookie: StoreJsAPI;
  clearableItems: string[] = ['cart', 'user', 'salla::wishlist', 'token'];

  constructor() {
    Salla.event.on("storage::item.remove", (key) => this.remove(key));
    Salla.event.on("storage::item.set", (key, value) => this.set(key, value));
    this.store = localStore;

    this.session = sessionStore;
    this.cookie = cookieStore;

  }

  set(key: string, value: unknown) {
    if (key.includes(".")) {
      const firstKey = key.split(".")[0];
      let parentObject = { [firstKey]: this.store.get(firstKey) };
      parentObject = Salla.helpers.setNested(parentObject, key, value);
      return this.store.set(firstKey, parentObject[firstKey]);
    }
    return this.store.set(key, value);
  }

  remove(key: string) {
    return this.store.remove(key);
  }

  clearAll(force = false) {
    if (force) {
      return  this.store.clearAll();
    }
    this.clearableItems.forEach(key => {
      this.store.remove(key);
    });
  }

  get(key, value) {
    if (key.includes(".")) {
      const firstKey = key.split(".")[0];
      return Salla.helpers.getNested({ [firstKey]: this.store.get(firstKey) }, key);
    }
    return this.store.get(key, value);
  }

  private prefixKey(key: string) {
    return `${key}_${Salla.config.get('store.id')}`
  }

  setWithTTL(key: string, value: unknown, ttlInMinutes = 10, store: 'store' | 'session' | 'cookie' = 'store') {

    const prefixedKey = this.prefixKey(key)
    const expiry = new Date().getTime() + (ttlInMinutes * 60 * 1000)
    return this[store].set(prefixedKey, {
      value,
      expiry
    });
  }

  getWithTTL(key: string, defaultValue = null, store: 'store' | 'session' | 'cookie' = 'store') {

    const prefixedKey = this.prefixKey(key)
    const item = this[store].get(prefixedKey) as (ItemWithTTL | null);

    if (!item) {
      return defaultValue;
    }
    const isItemExpired = new Date().getTime() > item.expiry

    if (isItemExpired) {
      this[store].remove(prefixedKey);
      return defaultValue;
    }

    return item.value;
  }
}
